var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};


//////////////////
// WEBPACK FOOTER
// /app/node_modules/core-js/library/modules/_has.js
// module id = 117
// module chunks = 0